<div
  class="download-handbook-form-container"
  [ngClass]="{ 'nav-fixed': actualPage }"
>
  <div class="sidenav-header-container">
    <h3 *ngIf="portName !== ''" class="title">
      Download {{ portName | titlecase }} handbook
    </h3>
    <h3 *ngIf="portName === ''" class="title">Download full handbooks</h3>
    <button mat-icon-button (click)="onSidenavClosed()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <p class="info-text">
      Complete your information below to receive the full handbook of the
      selected(s) port(s). View list of terminals, restrictions, rates, services
      and more.
    </p>
    <p *ngIf="data.length !== undefined">
      {{ getSelectedPorts()?.length }} handbook<span
        *ngIf="getSelectedPorts()?.length > 1"
        >s</span
      >
      will be sent to your corporate email
    </p>
    <div
      *ngIf="data.length !== undefined"
      class="checkbox-container"
      [formGroup]="formGroup"
    >
      <div formArrayName="ports">
        <div
          *ngFor="let port of formGroup.get('ports').controls; let i = index"
          [formGroupName]="i"
        >
          <p>
            <mat-checkbox
              [checked]="port.value.descricao"
              [value]="port.value.descricao"
              formControlName="checked"
              (change)="checkControl(port.value.descricao)"
              >{{ port.value.descricao }}</mat-checkbox
            >
          </p>
        </div>
      </div>
    </div>
    <mat-form-field class="download-handbook-form" appearance="outline">
      <mat-label>Full name*</mat-label>
      <input
        class="input-client-information"
        matInput
        placeholder="Type your full name"
        formControlName="name"
        (click)="$event.stopPropagation()"
        [ngClass]="{ 'is-invalid': submitted && f.name.errors }"
      />
    </mat-form-field>
    <mat-form-field class="download-handbook-form" appearance="outline">
      <mat-label>Corporate e-mail*</mat-label>
      <input
        class="input-client-information"
        matInput
        placeholder="Type your corporate address"
        formControlName="email"
        (click)="$event.stopPropagation()"
        [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
      />
    </mat-form-field>
    <mat-form-field class="download-handbook-form" appearance="outline">
      <mat-label>Company name</mat-label>
      <input
        class="input-client-information"
        matInput
        placeholder="Type your company name (optional)"
        formControlName="company"
        (click)="$event.stopPropagation()"
      />
    </mat-form-field>
    <div class="checkbox-agreed">
      <p class="checkbox-container-text">
        <mat-checkbox formControlName="agreed" class="checkbox">
          I agree to receive communications from Wilson Sons
        </mat-checkbox>
      </p>
    </div>
    <div class="button-container">
      <button
        [disabled]="getSelectedPorts()?.length === 0 || !formGroup.valid"
        mat-button
        class="send-button"
      >
        Send
      </button>
    </div>
  </form>
</div>
